import { useQuery } from '@tanstack/react-query'
import { fetchParty, partyKeys } from '@/services/parties'

export function useParty(id: string | undefined) {
  const partyQuery = useQuery({
    queryKey: partyKeys.detail(id!),
    queryFn: () => fetchParty(id!),
    enabled: !!id,
  })

  return {
    party: partyQuery.data,
    isLoading: partyQuery.isLoading,
    error: partyQuery.error,
  }
}
